const bundledDemoMedia: Readonly<Record<string, string>> = Object.freeze({
  "demo:field-user-portrait": "/demo/media/field-user-portrait.webp",
  "demo:flood-pump": "/demo/media/flood-pump.webp",
  "demo:response-vehicle": "/demo/media/response-vehicle.webp",
  // Compatibility with already-seeded local demo databases.
  "synthetic-equipment-placeholder-v1": "/demo/media/flood-pump.webp",
  "synthetic-person-avatar-v1": "/demo/media/field-user-portrait.webp",
  "synthetic-vehicle-placeholder-v1": "/demo/media/response-vehicle.webp",
});

const DOCUMENT_KEY = /^document:([A-Za-z0-9._:-]{1,128})$/;

/** Resolve only governed same-origin media keys. Arbitrary and external URLs fail closed. */
export function mediaUrlForKey(key: string | null | undefined): string | null {
  const normalized = key?.trim();
  if (!normalized) return null;
  const bundled = bundledDemoMedia[normalized];
  if (bundled !== undefined) return bundled;
  const documentId = DOCUMENT_KEY.exec(normalized)?.[1];
  return documentId === undefined
    ? null
    : `/api/v1/documents/${encodeURIComponent(documentId)}/content`;
}
